<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局覆盖 Element UI 默认字体大小 */
.el-form-item__label {
  font-size: 13px !important;
  line-height: 32px !important;
}

.el-input__inner,
.el-textarea__inner,
.el-input-number .el-input__inner {
  font-size: 13px !important;
  height: 32px !important;
}

.el-button,
.el-button--small,
.el-button--text {
  font-size: 13px !important;
}

.el-table,
.el-table__body,
.el-table td,
.el-table th {
  font-size: 13px !important;
}

.el-descriptions__label,
.el-descriptions__content {
  font-size: 13px !important;
}

.el-tag {
  font-size: 12px !important;
  height: 22px !important;
  line-height: 20px !important;
}

/* Tab 标签保持稍微大一点（可选） */
.el-tabs__item {
  font-size: 14px !important;
}
</style>